import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { BlogService } from 'src/app/services/blog.service';

@Component({
  selector: 'app-blogs-list',
  templateUrl: './blogs-list.component.html',
  styleUrls: ['./blogs-list.component.scss']
})
export class BlogsListComponent implements OnInit {

  constructor(private router: Router, private blogService: BlogService, public authService: AuthService) { }
  public pdfPath = "";
  blogs:any[] = [];
  ngOnInit(): void {
    this.blogService.getBlog('blogs').subscribe(
      (res:any)=>{
        this.blogs = res;
      }
    )
  }

  onClickBlog(blog){
    // this.router.navigate([''])
    window.open('blogPost/pdf/'+blog._id, '_blank');
  }

  onClickMore(){
    this.router.navigate(['blogs/all']);
  }

  onClickAdd(){
    this.router.navigate(['blogs/add']);
  }
}
